export default class ChartPDFDateFormattingStrategy {
    constructor(dateFormat, dateFormatForFileName) {
        this.dateFormat = dateFormat;
        this.dateFormatForFileName = dateFormatForFileName;
    }

    formatFileNameDate(date) {
        return this.dateFormatForFileName.formatDate(date)
    }

    formatDateForFileName(dateParameters){
        // abstract
    }

    formatDateInformation(dateParameters) {
        // abstract
    }
}



// WEBPACK FOOTER //
// ./web/js/pdf/formatters/ChartPDFDateFormattingStrategy.js